import { useState } from "react";
import { languages } from "../constants";
import { GlobeIcon } from "../../icons";

const LanguageSwitcher = ({ lang, setLang }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (language) => {
    setLang(language);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const language = languages?.filter((l) => l.value === lang)[0];

  return (
    <div className="relative">
      <div
        className={`text-black flex cursor-pointer justify-center items-center`}
        onClick={toggleDropdown}
      >
        <GlobeIcon />
        <div className="mx-1 uppercase text-[13px]">{language?.label}</div>
        <svg
          className={`transition-transform duration-200 ${
            isOpen ? "transform rotate-180" : ""
          }`}
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="5"
          viewBox="0 0 10 5"
          fill="none"
        >
          <path d="M0 0L5 5L10 0H0Z" fill="#0073FF" />
        </svg>
      </div>
      {isOpen && (
        <div className="z-50 absolute top-10 -left-[50px] list-none bg-[#ffffff] shadow-lg w-[143px] h-[170px] rounded-[6px] border border-[rgba(249,249,249,0.40)]  px-1 py-[10px]">
          <ul className="overflow-y-auto h-full space-y-2" role="none">
            <div className="text-[10px] font-semibold leading-[22px] px-1 text-[#000]">
              Select Language
            </div>
            {languages?.map((lang) => (
              <li key={lang?.value}>
                <span
                  className={`transition-all capitalize duration-800 ease-in-out flex items-center px-[10px] h-[22px]  text-black cursor-pointer leading-[24px]  text-[12px] rounded-[4px] ${
                    language?.value === lang?.value
                      ? "bg-[#0073FF] shadow text-white"
                      : "hover:bg-[#EAF3FF]"
                  }`}
                  onClick={() => {
                    handleLanguageChange(lang?.value);
                  }}
                >
                  {lang?.value}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
export default LanguageSwitcher;
